import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MdIconComponent } from '@inditex/mduikit';
import { TranslateModule } from '@ngx-translate/core';
import { SwiperModule } from 'swiper/angular';

import { StudioMultiProductTemplateComponent } from './components/studio-multi-product-template/studio-multi-product-template.component';
import { StudioNslaTemplateComponent } from './components/studio-nsla/studio-nsla-template.component';
import { StudioSingleProductTemplateComponent } from './components/studio-single-product-template/studio-single-product-template.component';
import { StudioSliderTemplateComponent } from './components/studio-slider-template/studio-slider-template.component';
import { Studiot4sComponent } from './components/studio-t4s/studio-t4s.component';
import { StudioTemplatesComponent } from './components/studio-templates/studio-templates.component';
import { MultiProductTemplateConfigurations } from './configs/multi-product-template.configs';
import { SingleProductTemplateConfigurations } from './configs/single-product-template.configs';
import { StudioTemplateConfigurations } from './configs/studio-template-configs';
import { StudioTemplateDirective } from './directives/studio-template.directive';

import { SlideElementsComponent } from '@features/cms-collection';
import { PricesModule } from '@shared/prices/prices.module';
import { ProductViewComponent } from '@shared/product/components/product-view/product-view.component';
import { ProductViewMonoStudioComponent } from '@shared/product/components/product-view-mono-studio/product-view-mono-studio.component';
import { ProductMocacoService } from '@shared/product/services/product-mocaco.service';
import { ParagraphToggleComponent } from '@ui/paragraph-toggle/paragraph-toggle.component';

export const studioTemplatesDeclarations = [
    StudioTemplateDirective,
    StudioSingleProductTemplateComponent,
    StudioMultiProductTemplateComponent,
    StudioTemplatesComponent,
    Studiot4sComponent,
    StudioSliderTemplateComponent,
    StudioNslaTemplateComponent,
];

@NgModule({
    declarations: studioTemplatesDeclarations,
    imports: [
        CommonModule,
        MdIconComponent,
        ParagraphToggleComponent,
        PricesModule,
        ProductViewComponent,
        ProductViewMonoStudioComponent,
        SlideElementsComponent,
        SwiperModule,
        TranslateModule,
    ],
    exports: studioTemplatesDeclarations,
    providers: [
        MultiProductTemplateConfigurations,
        ProductMocacoService,
        SingleProductTemplateConfigurations,
        StudioTemplateConfigurations,
    ],
})
export class StudioTemplatesModule { }
